import { render, staticRenderFns } from "./security.vue?vue&type=template&id=5b9e4fb8&scoped=true"
import script from "./security.vue?vue&type=script&lang=js"
export * from "./security.vue?vue&type=script&lang=js"
import style1 from "./security.vue?vue&type=style&index=1&id=5b9e4fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9e4fb8",
  null
  
)

export default component.exports